import { useSubsequentEffect } from '@carvana/merch-react-hooks';
import { useContext, useState } from 'react';
import AnimateHeight from '@/common/AnimateHeight';
import AppliedFiltersContext from '~/context/common/AppliedFiltersContext';
import { useFacetData } from '~/context/common/FacetDataContext';
import FilterDrawer from './FilterDrawer';
import { Label } from './FiltersMenu.styles';
import useRangeUpdater from './hooks/useRangeUpdater';
import InputRangeSlider from './InputRangeSlider';

export default function TowingCapacity() {
  const { appliedFilters } = useContext(AppliedFiltersContext);
  const facetData = useFacetData();
  const [rangeValues, setRangeValues] = useState([
    appliedFilters.towingCapacity?.min ?? facetData.towingCapacity?.min ?? 0,
    appliedFilters.towingCapacity?.max ?? facetData.towingCapacity?.max ?? 0
  ]);

  useSubsequentEffect(() => {
    setRangeValues([
      appliedFilters.towingCapacity?.min ?? facetData.towingCapacity?.min ?? 0,
      appliedFilters.towingCapacity?.max ?? facetData.towingCapacity?.max ?? 0
    ]);
  }, [
    appliedFilters.towingCapacity?.max,
    appliedFilters.towingCapacity?.min,
    facetData.towingCapacity?.max,
    facetData.towingCapacity?.min
  ]);

  const show = Boolean(
    facetData.towingCapacity && facetData.towingCapacity?.min > 0
  );

  const onUpdate = useRangeUpdater({
    filterKey: 'towingCapacity',
    max: facetData.towingCapacity?.max,
    min: facetData.towingCapacity?.min
  });

  return (
    <AnimateHeight show={show}>
      <FilterDrawer
        testId="facet-towing-capacity"
        facetContent={facetData.towingCapacity}
        facetName="Towing Capacity"
      >
        <Label>Towing capacity</Label>
        <InputRangeSlider
          data-analytics-id="adjust-towing-capacity-range"
          format="number"
          idPrefix="towing"
          min={facetData.towingCapacity?.min}
          max={facetData.towingCapacity?.max}
          thumbBehavior="slide-through"
          value={rangeValues}
          onValueChange={value => {
            setRangeValues(value);
          }}
          onValueCommit={value => {
            onUpdate(value);
          }}
        />
      </FilterDrawer>
    </AnimateHeight>
  );
}
